document.addEventListener('DOMContentLoaded', () => {
  // 機能: 年間スケジュールテーブルの自動スクロール
  // 概要: ページロード時、横スクロール可能なテーブルを当月表示位置まで移動させる。
  //       テーブルの左側に固定列がある場合、その幅を考慮し、固定列の右側に当月が表示されるように調整する。

  // ターゲット要素のセレクタ定義
  const TABLE_SELECTOR = '.js-yearlySchedule';
  const CURRENT_MONTH_HEADER_SELECTOR = '.current-month';
  const STICKY_HEADER_SELECTOR = 'th.table-sticky-header';
  const SCROLL_CONTAINER_SELECTOR = '.table-responsive';

  // スクロール対象となる年間スケジュールテーブルのDOM要素を取得
  // .table-responsive (overflow: scroll) 内の table.js-yearlySchedule を想定
  const yearlyScheduleTable = document.querySelector(TABLE_SELECTOR);

  // テーブル要素の存在チェック
  if (yearlyScheduleTable) {
    // 現在の月を示すヘッダーセル (`th.current-month`) のDOM要素を取得
    const currentMonthHeader = yearlyScheduleTable.querySelector(CURRENT_MONTH_HEADER_SELECTOR);

    // テーブルの固定列ヘッダー (`th.table-sticky-header`) のDOM要素を取得
    // この要素の幅は、スクロール位置調整のためのオフセットとなる。
    const stickyHeader = yearlyScheduleTable.querySelector(STICKY_HEADER_SELECTOR);

    // 必須要素（当月ヘッダー、固定列ヘッダー）の存在チェック
    if (currentMonthHeader && stickyHeader) {
      // 横スクロールを制御する親コンテナ (`div.table-responsive`) のDOM要素を取得
      // closest() は、要素自身を含む最も近い祖先要素を返す。
      const scrollContainer = yearlyScheduleTable.closest(SCROLL_CONTAINER_SELECTOR);

      // スクロールコンテナの存在チェック
      if (scrollContainer) {
        // 固定列のオフセット幅を計算
        const stickyWidth = stickyHeader.offsetWidth;

        // 当月ヘッダーのテーブルコンテンツ内における左端オフセットを取得
        const currentMonthOffset = currentMonthHeader.offsetLeft;

        // 目標スクロール位置を算出:
        // 当月ヘッダーの左端オフセットから固定列の幅を引くことで、
        // 当月ヘッダーが固定列のすぐ右側に表示されるよう調整する。
        const desiredScrollLeft = currentMonthOffset - stickyWidth;

        // スクロールコンテナの水平スクロール位置を設定
        // 計算結果が負の値になる場合は0にクランプ（左端より左にはスクロールしない）
        scrollContainer.scrollLeft = Math.max(0, desiredScrollLeft);

        // デバッグログ: スクロール実行時の位置情報
        // console.log(`[${yearlyScheduleTable.className.split(' ').filter(c => c.startsWith('js-')).join(', ')}] スクロール完了。当月オフセット: ${currentMonthOffset}px, 固定列幅: ${stickyWidth}px, 最終スクロール位置: ${scrollContainer.scrollLeft}px`);
      } else {
        // エラーログ: 必須DOM要素の不足 (スクロールコンテナ)
        // console.warn(`[${TABLE_SELECTOR}] エラー: 横スクロール可能な親コンテナ (${SCROLL_CONTAINER_SELECTOR}) が見つかりませんでした。`);
      }
    } else {
      // 警告ログ: 必須DOM要素の不足 (当月ヘッダーまたは固定列ヘッダー)
      // console.warn(`[${TABLE_SELECTOR}] 警告: 当月ヘッダー (${CURRENT_MONTH_HEADER_SELECTOR}) または固定列ヘッダー (${STICKY_HEADER_SELECTOR}) が見つかりませんでした。自動スクロールは実行されません。`);
    }
  }
  // 当該テーブルが存在しないページでのエラー回避のため、テーブル要素がnullの場合は何もせず終了。
});
